module.exports = __webpack_public_path__ + "static/media/Planning.ec783cc1.png";